import amapi from '@/api/amapi'

const initialState = () => ({
  answered: true,
  survey: {},
})

const state = initialState

const getters = {
  getSurvey: state => state.survey,
  getAnswered: state => state.answered,
}

const mutations = {
  SET_SURVEY (state, survey) {
    state.survey = survey
  },
  SET_ANSWERED (state, answered) {
    state.answered = answered
  },
}

const actions = {
  async loadSurvey ({ commit }) {
    try {
      const { answered, survey } = await amapi.makecall('onboarding_survey')
      if (answered) {
        commit('SET_ANSWERED', answered)
        return
      }
      commit('SET_ANSWERED', answered)
      commit('SET_SURVEY', survey)
    } catch (err) {
      throw err
    }
  },
  async respondSurvey ({ commit, dispatch }, payload) {
    try {
      const raw = await amapi.makecall('onboarding_survey', payload)
      const resp = raw ?? { result: false, resultmsg: 'No response from API.' }
      if (resp.result === 'success') {
        commit('SET_ANSWERED', true)
        dispatch('reportSuccess', 'Thanks for sharing! This helps us personalize your experience.')
      } else {
        dispatch('reportError', resp.resultmsg || 'Submission failed.')
      }
      return resp
    } catch (err) {
      const resp = { result: false, resultmsg: err || 'Network error' }
      dispatch('reportError', resp.resultmsg)
      return resp
    }
  },
}

const survey = {
  state,
  getters,
  mutations,
  actions
}

export default survey
